// extracted by mini-css-extract-plugin
module.exports = {"container":"recipient-email_container__3_aXX","icon":"recipient-email_icon__1vB9g","wrapper":"recipient-email_wrapper__1eU0E","notice":"recipient-email_notice__VSNIZ"};